import { render, staticRenderFns } from "./editBunkersOnTable.vue?vue&type=template&id=ea1cd7ba&scoped=true"
import script from "./editBunkersOnTable.vue?vue&type=script&lang=js"
export * from "./editBunkersOnTable.vue?vue&type=script&lang=js"
import style0 from "./editBunkersOnTable.vue?vue&type=style&index=0&id=ea1cd7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1cd7ba",
  null
  
)

export default component.exports